import baseApi from 'api/baseApi';
import { IPaymentMethodCustomResponse } from 'common/interfaces/invoices';

const posApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getPaymentCustomMethod: builder.query<
      IPaymentMethodCustomResponse,
      { clubId: number; barcode: string }
    >({
      query: ({ clubId, barcode }) => ({
        url: `/api/v1/member-portal/pos/payment-methods/custom/instance/${clubId}`,
        method: 'GET',
        params: { barcode },
      }),
    }),
  }),
});

export const { useLazyGetPaymentCustomMethodQuery } = posApi;

export default posApi;
